(() => {
  // Visual-only utility: no interception of Shopify links, forms or cart actions.
  const body = document.body;
  let frame = 0;

  const button = document.createElement('button');
  button.id = 'legacy-back-to-top';
  button.type = 'button';
  button.setAttribute('aria-label', 'Back to top');
  button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 14.5 12 8l6 6.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(button);

  const update = () => {
    frame = 0;
    const scrolled = window.scrollY > 18;
    body.classList.toggle('legacy-has-scrolled', scrolled);
    button.classList.toggle('is-visible', window.scrollY > Math.max(500, window.innerHeight * .75));
  };
  const requestUpdate = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
})();
